/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type {QcTriggerDocumentTypesResponse} from '../models/QcTriggerDocumentTypesResponse';
import type {CancelablePromise} from '../core/CancelablePromise';
import type {BaseHttpRequest} from '../core/BaseHttpRequest';
export class QcTriggerConfigInternalService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Returns the calling organization's configured Post-Closing QC trigger document type ids.
   * @returns QcTriggerDocumentTypesResponse OK
   * @throws ApiError
   */
  public qcTriggerConfigInternalGetQcTriggerDocumentTypes(): CancelablePromise<QcTriggerDocumentTypesResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/internal/qc/trigger-document-types',
      errors: {
        401: `Unauthorized`,
      },
    });
  }
}
